<div class="flex justify-content-center align-items-center h-full"
     [ngStyle]="{ transform: 'rotate(' + rotation() + 'deg)' }">
  <svg [attr.width]="width()" [attr.height]="height()" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.833374 10.8335L5.83337 5.8335L0.833374 0.833496" [attr.stroke]="stroke()" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</div>
